import { RadioCard, RadioGroup } from "@/components/ui/Radio";
import { useDonationFormStore } from "@/stores";
import { useTranslation } from "@/hooks/useTranslation";
import type { DonationIntentProps } from "./DonationIntentProps";
import { useLayoutEffect } from "react";

export function DonationIntent(props: DonationIntentProps) {
  const { className, config } = props;

  const { "donation-intent": options } = config;

  const { donationOneOffType, setDonationOneOffType, setCardEnabled } =
    useDonationFormStore();

  const t = useTranslation("donation_intent");

  useLayoutEffect(() => {
    if (options.length === 1) {
      const firstOptionValue = options[0].key;
      const enabledCard = options[0]["card-enabled"];
      setDonationOneOffType(firstOptionValue);
      setCardEnabled(enabledCard);
    }
  }, [options, setDonationOneOffType, setCardEnabled]);

  const hanldeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    const selectedOption = options.find((option) => option.key === value);

    if (selectedOption) {
      setDonationOneOffType(value);
      const enabledCard = selectedOption["card-enabled"];
      setCardEnabled(enabledCard);
    }
  };

  if (options.length <= 1) {
    return null;
  }

  return (
    <RadioGroup
      direction="column"
      name="one-off-donation-type"
      layout="auto-fit-large"
      value={donationOneOffType ?? ""}
      onChange={hanldeChange}
      className={className}
    >
      {options.map((option) => (
        <RadioCard
          key={option.key}
          boldTitle
          variant="secondary"
          title={t(option.type.i18n) as string}
          description={t(option.description.i18n)}
          value={option.key}
        />
      ))}
    </RadioGroup>
  );
}
